<template>
  <v-container :class="{'backgroundColor' : item.showDetail}">
    <v-row class="table-row d-flex">
      <v-col cols="4" class="pa-0">
        <div class="body-1">
          <div class="d-flex flex-row">
            <v-icon color="#F53BAD">mdi-cart</v-icon>
            <div class="d-flex">
              <span
                class="ml-3 d-flex subtitle-1 font-weight-medium"
                >{{ orderDelegates.name }}{{ item.original_order_id }}</span
              >
            </div>
          </div>

          <p
            class="secondary--font mt-4 ml-10 caption"
          >
            <span>Grand Total -</span>
            <span class="ml-2 text-color-green">
              {{ Number(item.grand_total) | currency("currencyCent") }}
            </span>
          </p>
          <div v-if="item.order_status" class="pb-0 ml-10">
            <v-chip
              outlined
              small
              :color="getStatusColor(item.order_status)"
              :text-color="getStatusColor(item.order_status)"
            >
              {{ item.order_status }}
            </v-chip>
          </div>
        </div>
      </v-col>
      <v-col md="4" sm="12" class="pa-0 d-flex flex-column flex-wrap ml-auto">
        <div
          v-if="orderDelegates.sourceIcons[item.source_type]"
          class="mb-4 ml-6"
        >
          <v-img
            :key="item.id"
            max-width="120px"
            width="100px"
            max-height="30px"
            height="30px"
            :src="
              require(`@core/assets/images/integration-icons/${
                orderDelegates.sourceIcons[item.source_type]
              }`)
            "
            contain
          ></v-img>
        </div>
        <div class="d-flex align-items-center justify-content-center ml-6" >
          <div><v-icon color="mpBlue">mdi-store</v-icon> </div>
          <p class="ml-2 word-break text-ellipsis body-2" >
            {{ item.source_name }}
          </p>
        </div>
      </v-col>
      <v-col cols="4" class="text-right pa-0 ">
        <p class="body-2">{{ $options.filters.formatDateTZ(item.order_date) }}</p>
        <p class="body-2 bold mb-0">
          <v-btn v-track="'order-detail'" outlined small class="mt-1" @click="toggleDetailPanel(item) "
          >
            <span class="font-weight-bold">{{
              item.showDetail ? "HIDE INFO" : "MORE INFO"
            }}</span>
          </v-btn>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="ma-0 px-8 py-1">
        <transition>
          <div v-if="item.showDetail" class="mt-4 ">
            <v-row class="expanded-inner-header  pl-2">
              <h3 class="body-1 mb-2">
                Order Details
                <a
                  v-if="
                    item.source_type === 'neto' ||
                    item.source_type === 'keap' ||
                    item.source_type === 'click_bank' ||
                    item.source_type === 'shopify'
                  "
                  :href="generateURL(item)"
                  target="_blank"
                  class="caption text-decoration-none"
                >
                  <span class="body-2 ml-6 primary--font font-weight-medium">View in Store</span>
                  <v-icon color="info" small> mdi-open-in-new </v-icon>
                </a>
              </h3>
            </v-row>
            <div v-if="item.loading" class="text-center pb-12">
              <v-progress-circular indeterminate size="40" class="pt-5 pb-12" />
            </div>
            <div v-else class="mb-2">
              <v-row class="expanded-inner-header service-order-margin text--disabled pa-0 pl-2">
                <v-col cols="1" class= "py-4 px-0 pl-0">Image</v-col>
                <v-col cols="5" class= "py-4 px-9">Order Items (SKU)</v-col>
                <v-col cols="2" class=" py-4 px-0">Price</v-col>
                <v-col cols="2" class=" py-4 px-0">Qty</v-col>
                <v-col cols="2" class=" py-4 px-0">Total Price</v-col>
              </v-row>
              <div>
                <v-row
                  v-for="(item, id) in item.orderDetail.order_items"
                  :key="id"
                  class="order-line-item d-flex align-center"
                >
                  <v-col
                    cols="1"
                    class="body-2 text-left product-images-wrapper"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card :class="{ 'on-hover': hover }" width="35">
                        <v-avatar
                          color="surface-variant"
                          rounded="0"
                          size="35px"
                          class="avatar-tile main-avatar"
                        >
                          <img
                            class="image-thumbnail"
                            :src="
                              item.product.image_url ||
                              require(`../../../assets/images/no-image.svg`)
                            "
                          />
                        </v-avatar>
                        <v-card class="hover-avatar-wrapper pa-1">
                          <v-avatar
                            elevation="2"
                            size="150px"
                            class="avatar-tile hover-avatar"
                            :class="{ 'show-thumbnail': hover }"
                          >
                            <v-img
                              class="thumbnail"
                              cover
                              :src="
                                item.product.image_url ||
                                require(`../../../assets/images/no-image.svg`)
                              "
                            />
                          </v-avatar>
                        </v-card>
                      </v-card>
                    </v-hover>
                  </v-col>
                  <v-col cols="5" class="body-2 px-11" style="width: 100px;" >
                    <div class="text-truncate">{{ item.product.name }} ({{ item.product.item_id }})</div>
                  </v-col>
                  <v-col cols="2" class="pa-1 body-2">
                    <v-tooltip top color="rgba(0, 0, 0, 0.9)">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ item.price | numberStatFormat("$") }}
                        </span>
                      </template>
                      <span>{{ item.price }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="2" class="pa-2 body-2">{{
                    item.quantity
                  }}</v-col>
                  <v-col cols="2" class="pa-1 body-2">
                    <v-tooltip top color="rgba(0, 0, 0, 0.9)">
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="pa-2">
                          {{
                            parseFloat((item.quantity * item.price).toFixed(2)) | numberStatFormat("$")
                          }}
                        </span>
                      </template>
                      <span>{{ item.quantity * item.price }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { $orders } from "@core/services";
import constants from "@core/config/constants";
export default {
  name: "contact-order",
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      orderDelegates: {
        name: "Order #",
        icon: "mdi-cart",
        sourceIcons: {
          shopify: "shopify.svg",
          zapier: "zapier.svg",
          salesforce: "salesforce-logo.png",
          shoppingcart: "1shoppingcart.png",
          ultracart: "ultracart.png",
          nanacast: "logo.png",
          cart: "3dcart_logo.png",
          dynamics: "dynamics-crm.png",
          magento: "magento-logo.png",
          neto: "neto.svg",
          commerce: "maropost_commerce.png",
          click_bank: "clickbank.png",
          retail_express: "retail-express.png",
          keap: "Infusionsoft.png",
        },
      },
      constants: constants,
    };
  },
  methods: {
    /**
     * Function to toggle order detail panel on clicking of Hide and Show button to toggle child items in the order.
     * @param {*} item
     */
    toggleDetailPanel(item, index) {
      item.showDetail = !item.showDetail;
      if (item.showDetail) {
        if (Object.keys(item.orderDetail).length == 0) {
          item.loading = true;
          $orders
            .show(item.id)
            .then((response) => {
              item.orderDetail = response.data.data.order;
            })
            .finally(() => {
              item.loading = false;
            });
        } 
      }
    },
    generateURL(item) {
      const store = item.source_name.split(".")[0];
      let orderPageUrl = "";
      if (item && item.source_type === "neto") {
        orderPageUrl = `https://${item.source_name}/_cpanel/order/vieworder?id=${item.original_order_id}`;
      }
      if (item && item.source_type === "shopify") {
        orderPageUrl = `https://admin.shopify.com/store/${store}/orders`;
      }
      if (item && item.source_type === "keap") {
        orderPageUrl = `https://${store}.infusionsoft.com/Job/manageJob.jsp?view=edit&ID=${item.original_order_id}`;
      }
      if (item && item.source_type === "click_bank") {
        orderPageUrl = `https://accounts.clickbank.com/master/findTxns.html`;
      }
      return orderPageUrl;
    },
    getStatusColor(status) {
      let constantOrderStatus = constants.ORDER_STATUS
      if(constantOrderStatus[status.toLowerCase()]) {
        return constantOrderStatus[status.toLowerCase()].color
      } else {
        return constantOrderStatus['default'].color
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text-color-green {
  color: #2a993e;
}
.text-color-blue {
  color: #207eb9;
}
.grey-border,
.expanded-inner-header {
  border-bottom: 1px solid lightgray;
}
.grey-color {
  color: #999999;
}
.order-line-item {
  border-bottom: 1px solid lightgray;
}
.order-line-item:hover {
  background-color: #cdf0fe;
  cursor: pointer;
}
.product-images-wrapper {
  .avatar-tile {
    border-radius: 0px !important;
  }
  .v-card {
    .main-avatar img {
      transition: filter 0.4s ease-in-out;
    }
    &.on-hover .main-avatar img {
      filter: brightness(25%);
    }
  }
  .hover-avatar {
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
  }
  .v-card.on-hover .hover-avatar-wrapper {
    visibility: visible !important;
  }
  .hover-avatar-wrapper {
    visibility: hidden;
    position: absolute;
    top: 0%;
    left: 0%;
    transform: translate(-0%, -110%);
    min-width: 158px;
    z-index: 1 !important;
  }
  .show-thumbnail {
    opacity: 1;
  }
  .tree-area {
    min-height: 300px;
    max-height: 300px;
    overflow: scroll;
  }
  .image-thumbnail {
    height: 30px;
    width: 30px;
  }
}
.backgroundColor {
  background: white !important;
}
::v-deep .v-image__image--contain {
    background-position: left !important;
}
</style>